import { Pipe, PipeTransform } from '@angular/core';
import { Analysis } from 'projects/dop-ordering/src/public-api';

@Pipe({
    name: 'analysisCodeDisplay'
})
export class AnalysisCodeDisplay implements PipeTransform {
    transform(analysis?: Analysis): any {
        if (analysis.testCode) {
            return `[${analysis.testCode}]`;
        } else if (analysis.packageCode) {
            return `[${analysis.packageCode}]`;
        }
        return '';
    }
}
